import { Component, computed, HostBinding, inject, input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { BaasAppState } from '@lvflanders/bar';

import { BaasUnavailableLayout } from '../../layout/baas-unavailable-layout/baas-unavailable-layout';

const DEFAULT_TITLE = 'Pagina onbeschikbaar';
const DEFAULT_CONTENT = 'De pagina is onbeschikbaar';

@Component({
    selector: 'baas-blocking-melding',
    templateUrl: './baas-blocking-melding.html',
    imports: [BaasUnavailableLayout]
})
export class BaasBlockingMelding implements OnInit {
    readonly #state = inject(BaasAppState);
    readonly #domSanitizer = inject(DomSanitizer);
    readonly title = input(DEFAULT_TITLE);
    readonly _content = input<string>(DEFAULT_CONTENT, { alias: 'content' });
    readonly content = computed(() => this.#domSanitizer.bypassSecurityTrustHtml(this._content()));
    readonly showGlobalHeaderFooter = input(false);
    readonly scaling = input<'none' | 'medium'>(undefined);
    protected homeUrl: string;

    @HostBinding('class.scaled-medium')
    protected get isMediumScaled() {
        return this.scaling() === 'medium';
    }

    ngOnInit(): void {
        this.homeUrl = <string>this.#state.config.homeUrl;
    }
}
